module.exports = __webpack_public_path__ + "static/media/web-ekyc-qr-code-stg.5d4633a1.png";